import DataRoomFile from './DataRoomFile.component';

export default DataRoomFile;
